import { SkyBadge } from "@skypointcloud/skypoint-ui";
import type { DisplayStatus } from "@shared/types/monitor";
import { STATUS_COLORS, statusLabel } from "@/lib/monitor/format";

/** A check's or a table's status: colour and label together, never colour alone (spec section 11). */
export function MonitorStatusBadge({ status, testId }: { status: DisplayStatus; testId?: string }) {
  return (
    <SkyBadge appearance="tint" color={STATUS_COLORS[status]} testId={testId}>
      {statusLabel(status)}
    </SkyBadge>
  );
}
